/**
 * @generated SignedSource<<c0c59a65672e4acbe9eda56bc8ae8cc2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type addEditOptionsExludedPropertiesQuery$variables = {
  id?: number | null;
};
export type addEditOptionsExludedPropertiesQuery$data = {
  readonly sys_mapping_sets: ReadonlyArray<{
    readonly provider: {
      readonly properties: ReadonlyArray<{
        readonly entity_id: string;
        readonly entity_name: string | null;
        readonly property_code: string;
        readonly property_name: string | null;
      }>;
    };
  }>;
};
export type addEditOptionsExludedPropertiesQuery = {
  response: addEditOptionsExludedPropertiesQuery$data;
  variables: addEditOptionsExludedPropertiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_eq",
                "variableName": "id"
              }
            ],
            "kind": "ObjectValue",
            "name": "mapping_set_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_mapping_sets",
    "kind": "LinkedField",
    "name": "sys_mapping_sets",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "sys_providers",
        "kind": "LinkedField",
        "name": "provider",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "where",
                "value": {
                  "is_active": {
                    "_eq": true
                  }
                }
              }
            ],
            "concreteType": "sys_properties",
            "kind": "LinkedField",
            "name": "properties",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entity_id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "entity_name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "property_code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "property_name",
                "storageKey": null
              }
            ],
            "storageKey": "properties(where:{\"is_active\":{\"_eq\":true}})"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addEditOptionsExludedPropertiesQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addEditOptionsExludedPropertiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "54e28fca1269597517a99e5b18dd76ab",
    "id": null,
    "metadata": {},
    "name": "addEditOptionsExludedPropertiesQuery",
    "operationKind": "query",
    "text": "query addEditOptionsExludedPropertiesQuery(\n  $id: Int\n) {\n  sys_mapping_sets(where: {mapping_set_id: {_eq: $id}}) {\n    provider {\n      properties(where: {is_active: {_eq: true}}) {\n        entity_id\n        entity_name\n        property_code\n        property_name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5411f53f432d5703ace9b05d70194a2d";

export default node;
